const getFormattedLabel = (label) => {
    if (!label) {
        return 'N/A';
    }
    // if label is not a string return N/A
    if (typeof label !== 'string') {
        return 'N/A';
    }
    // if label is expired_lead, terminated_lead, discount_type_1, discount-type-1
    // it should be Expired lead, Terminated lead, Discount type 1, Discount type 1
    const formattedLabel = label.replace(/_/g, ' ').replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());
    return formattedLabel;
};
export default getFormattedLabel;
